import { ApiV2 } from "./Api";

// <{
//   subscriptionsAmount: number;
//   usersNotRegistered?: string[];
//   notRegisteredSuggestions?: any[];
// }>

export const importarCSV = (idPalestra, csv) => {
  const form = new FormData();
  form.append("csv", csv);
  return ApiV2().post(`/presenca/import-csv/${idPalestra}`, form);
};

export const importarCPF = (idPalestra, cpf) => {
  return ApiV2().post(`/presenca/${idPalestra}`, { cpf });
};

export const exportarCSVPresencas = (dates, minTimeMinutes, filter) => {
  return ApiV2().get(`/presenca/presentes`, {
    params: { dates, minTimeMinutes, filter },
  });
};
